import React from 'react';
import { IconButton } from '@paypalcorp/pp-react';
import { closeWindow, isInContext } from '../utility/inContextDonation';
import TemplateData from '../utility/getTemplateData';
import * as FPT from '../utility/fpt';
import { EVENT_NAME } from '../utility/constants';

export default function CloseButton() {
  const handleClose = () => {
    const eventName =
      window.location.href.includes('confirmation') ||
      window.location.href.includes('pending')
        ? EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_DISMISS_PRESSED
        : EVENT_NAME.DW_GIVING_DONATE_SETUP_DISMISS_PRESSED;
    FPT.trackLinkClickWithData('cancel', {
      event_name: eventName,
    });
    if (isInContext()) {
      closeWindow();
      return;
    }
    window.location.href = TemplateData.charityCancelUrl;
  };
  return (
    <IconButton
      data-testid="close-button"
      iconName="close"
      onClick={handleClose}
      className="close-button"
    />
  );
}
